export default {
  methods: {
    getRailsIdFromFieldName(name) {
      return name
        .replace(/]/g, "")
        .split("[")
        .join("_");
    },
  },
};
